import React from 'react';
export const EventBusStoreContext = React.createContext(undefined);
export const useEventBusStore = () => React.useContext(EventBusStoreContext);
